import { Component, inject } from '@angular/core';
import { GeneticMaterialGroupService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GeneticMaterialGroupCreateDto,
  GeneticMaterialGroupDto,
  GeneticMaterialGroupExcelDownloadDto,
  GeneticMaterialGroupUpdateDto,
} from '../proxy/general/dtos/genetic-material-group';
import { GENETICMATERIALGROUP_CONFIG, GENETICMATERIALGROUP_FIELDS } from './genetic-material-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-genetic-material-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GeneticMaterialGroupService, ConfirmationService],
  templateUrl: './genetic-material-group.html',
  styleUrl: './genetic-material-group.scss',
})
export class GeneticMaterialGroup extends BaseCrudComponent<
  GeneticMaterialGroupDto,
  GeneticMaterialGroupCreateDto,
  GeneticMaterialGroupUpdateDto,
  GeneticMaterialGroupExcelDownloadDto
> {
  service = inject(GeneticMaterialGroupService);
  config = GENETICMATERIALGROUP_CONFIG;
  fields = GENETICMATERIALGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: GeneticMaterialGroupDto): GeneticMaterialGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GeneticMaterialGroup';
  }
}
